import Button from "components/base/Button";
import { Input, Text } from "components/base/Form";

const GenerateCpcCertificateFields = ({
  form,
  onChange,
  imageUrls,
  rows,
  addRowHandler,
  changeRowHandler,
  removeRowHandler,
  usImporterDomesticManufacturer,
  setUsImporterDomesticManufacturer,
  personMaintainingRecords,
  setPersonMaintainingRecords,
}) => {
  return (
    <>
      <section className="space-y-4">
        <div className="flex items-start justify-between gap-6">
          <h3>
            CHILDREN&apos;S PRODUCT CERTIFICATE
            <br />
            FOR
            <br />
            CONSUMER PRODUCT SAFETY IMPROVEMENT ACT
          </h3>
          <div className="text-right">
            <img
              src="https://cdn.waboba.com/public/waboba-logo-w-waboba.png"
              alt="Waboba"
              className="h-12 ml-auto py-2"
            />
            <div className="opacity-70 mt-1">{form.certificateNumber}</div>
          </div>
        </div>
      </section>

      <section className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h5>US IMPORTER/DOMESTIC MANUFACTURER</h5>
            <Text
              className="mt-3"
              rows={8}
              value={usImporterDomesticManufacturer}
              onChange={(e) => setUsImporterDomesticManufacturer(e.target.value)}
            />
          </div>
          <div>
            <h5>PERSON MAINTAINING RECORDS</h5>
            <Text
              className="mt-3"
              rows={8}
              value={personMaintainingRecords}
              onChange={(e) => setPersonMaintainingRecords(e.target.value)}
            />
          </div>
        </div>
      </section>

      <section className="space-y-4">
        <div className="-mx-2">
          <table>
            <tbody>
              <tr>
                <td className="w-44">
                  <label>Sample Description</label>
                </td>
                <td colSpan={3}>
                  <Input
                    className="w-full"
                    value={form.sampleDescription}
                    onChange={(e) => onChange("sampleDescription", e.target.value)}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <label>Manufacturer</label>
                </td>
                <td>
                  <Input
                    className="w-full"
                    value={form.manufacturer}
                    onChange={(e) => onChange("manufacturer", e.target.value)}
                  />
                </td>
                <td className="w-44">
                  <label>Style No(s)</label>
                </td>
                <td>
                  <Input
                    className="w-full"
                    value={form.styleNos}
                    onChange={(e) => onChange("styleNos", e.target.value)}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <label>Place of Manufacturer</label>
                </td>
                <td>
                  <Input
                    className="w-full"
                    value={form.placeOfManufacturer}
                    onChange={(e) =>
                      onChange("placeOfManufacturer", e.target.value)
                    }
                  />
                </td>
                <td>
                  <label>Country of Origin</label>
                </td>
                <td>
                  <Input
                    className="w-full"
                    value={form.countryOfOrigin}
                    onChange={(e) => onChange("countryOfOrigin", e.target.value)}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <label>Date of Manufacturer</label>
                </td>
                <td>
                  <Input
                    className="w-full"
                    value={form.dateOfManufacturer}
                    onChange={(e) =>
                      onChange("dateOfManufacturer", e.target.value)
                    }
                  />
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td className="align-top pt-2">
                  <label>Place of Testing</label>
                </td>
                <td colSpan={3}>
                  <Text
                    className="w-full"
                    rows={5}
                    value={form.placeOfTesting}
                    onChange={(e) => onChange("placeOfTesting", e.target.value)}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <label>Test Report Number</label>
                </td>
                <td>
                  <Input
                    className="w-full"
                    value={form.testReportNumber}
                    onChange={(e) => onChange("testReportNumber", e.target.value)}
                  />
                </td>
                <td>
                  <label>Date of Testing</label>
                </td>
                <td>
                  <Input
                    className="w-full"
                    value={form.dateOfTesting}
                    onChange={(e) => onChange("dateOfTesting", e.target.value)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section className="space-y-4">
        {imageUrls.length > 0 ? (
          <div className="flex flex-wrap gap-3">
            {imageUrls.map((url, index) => (
              <img
                key={`${url}-${index}`}
                src={url}
                alt="Certificate"
                className="w-32 h-32 object-cover rounded border border-gray-200 dark:border-gray-700"
              />
            ))}
          </div>
        ) : null}

        <Text
          rows={3}
          value={form.certifyText}
          onChange={(e) => onChange("certifyText", e.target.value)}
        />

        <div>
          The following rules, bans, standards and regulations were tested for
          this product:
        </div>

        <div className="-mx-2">
          <table className="with-line">
            <thead>
              <tr>
                <th>Applicable Standards and Regulations</th>
                <th className="w-32">Law / Act</th>
                <th>Federal Regulations Title 16 CFR Part No. / Section No.</th>
                <th className="w-16"></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  <td>
                    <Input
                      className="w-full"
                      value={row.standard}
                      onChange={(e) =>
                        changeRowHandler(index, "standard", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <Input
                      className="w-full"
                      value={row.lawAct}
                      onChange={(e) =>
                        changeRowHandler(index, "lawAct", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <Input
                      className="w-full"
                      value={row.federalNo}
                      onChange={(e) =>
                        changeRowHandler(index, "federalNo", e.target.value)
                      }
                    />
                  </td>
                  <td className="text-right">
                    <Button
                      trash
                      onClick={() => removeRowHandler(index)}
                      disabled={rows.length === 1}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <Button onClick={addRowHandler}>+ Add Row</Button>
      </section>

      <section className="space-y-3">
        <h5>Note:</h5>
        <Text
          rows={10}
          value={form.notes}
          onChange={(e) => onChange("notes", e.target.value)}
        />
      </section>
    </>
  );
};

export default GenerateCpcCertificateFields;
